<template>
    <div>
        <el-container>
            <el-header>富文本</el-header>
            <el-main>
                <el-row>
                    <el-col :span="6"><div class="grid-content bg-purple">
                        <el-button type="primary" @click="aa('http://heiline.ltd/editor/1/2020330.html')">纯JS富文本</el-button>
                    </div></el-col>
                    <el-col :span="6"><div class="grid-content bg-purple-light">
                        <el-button type="primary" @click="aa('http://heiline.ltd/editor/2/edit.html')">多功能富文本</el-button>
                    </div></el-col>
                    <el-col :span="6"><div class="grid-content bg-purple">
                        <el-button type="primary" @click="aa('http://heiline.ltd/editor/3/61.html')">仿wangeditor简单版</el-button>
                    </div></el-col>
                    <el-col :span="6"><div class="grid-content bg-purple">
                        <el-button type="primary" @click="aa('http://heiline.ltd/editor/4/61.html')">仿wangeditor过渡版</el-button>
                    </div></el-col>
                </el-row>
                <iframe :src="src" width="100%" height="800" frameborder="0" scrolling="auto" id="iframename" name="iframename">
                    <meta http-equiv=”Content-Type” content=”text/html; charset=u″ />
                </iframe>
<!--                    <html>-->
<!--                    <head>-->
<!--                        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />-->
<!--                    </head>-->
<!--                    <iframe :src="src" width="100%" height="800" frameborder="0" scrolling="auto" id="iframename" name="iframename"></iframe>-->
<!--                    </html>-->




            </el-main>
        </el-container>

    </div>
</template>

<script>
    export default {
        name: "IntroudeceEditorP",
        data(){
            return{
                src:'http://heiline.ltd/editor/4/61.html',
            }
        },
        methods:{
            aa(value){
                this.src=value;
            }
        }
    }
</script>

<style scoped>
    .el-header, .el-footer {
        background-color: #B3C0D1;
        color: #333;
        text-align: center;
        line-height: 60px;
    }

    .el-aside {
        background-color: #D3DCE6;
        color: #333;
        text-align: center;
        line-height: 200px;
    }

    .el-main {
        background-color: #E9EEF3;
        color: #333;
        text-align: center;
        line-height: 160px;
    }

    body > .el-container {
        margin-bottom: 40px;
    }

    .el-container:nth-child(5) .el-aside,
    .el-container:nth-child(6) .el-aside {
        line-height: 260px;
    }

    .el-container:nth-child(7) .el-aside {
        line-height: 320px;
    }
</style>